console.log("custom");
$(document).ready(function(){
  console.log("out");
  if($("body").hasClass("template--product") == true && $(".swatch_options.collection_swatches").hasClass("product--has_back_cushion") == true ){
    console.log("ifff");
    $('.swatch.has_back_cousin_color input[type="radio"].swatch--none').trigger("click");
    $("#AddToCart-product-template").attr("disabled","disabled");
    
    $(document).on("click",".btnBackCausion--yes",function(){
      $("#AddToCart-product-template").removeAttr("disabled","disabled");
      $(this).parents('.swatch_options').addClass('add-back-causion');
      $(this).parents('.swatch_options').addClass('cusion_option_selected');
      $(".btn_add_back_causion").removeClass("checked");
      $(this).addClass("checked");
      var parent = $(this).parents(".has_back_cousin_color"),
          checked_sheat_color = parent.prev().find('input[type="radio"]:checked').data("handalize--title"),
          value = parent.find('input[type="radio"][data-handalize--title="'+checked_sheat_color+'"]').attr('aria-label');
      parent.find('input[type="radio"][data-handalize--title="'+checked_sheat_color+'"]').trigger("click");
      parent.find('input[type="hidden"]').val(value);
    });
    
    $(document).on("click",".btnBackCausion--no",function(){
      $("#AddToCart-product-template").removeAttr("disabled","disabled");
      $(this).parents('.swatch_options').removeClass('add-back-causion');
      $(this).parents('.swatch_options').addClass('cusion_option_selected');
      $(".btn_add_back_causion").removeClass("checked");
      $(this).addClass("checked");
      $(this).parents(".has_back_cousin_color").find('input[type="radio"].swatch--none').trigger("click");
      var selected_value = $(this).parents(".has_back_cousin_color").find('input[type="radio"].swatch--none').attr('aria-label');
      $(this).parents(".has_back_cousin_color").find('input[type="hidden"]').val(selected_value);
    });
    
    $(document).on("change",'input[type="radio"]',function(){
      
      if($(this).parents('.swatch_options').hasClass('cusion_option_selected')){
        $("#AddToCart-product-template").removeAttr("disabled","disabled");
      }else{
        $("#AddToCart-product-template").attr("disabled","disabled");
      }
      
      if($(this).parents('.swatch_options').hasClass('add-back-causion')){
        var current_selected = $(this).data("handalize--title");
        var selected_value = $(this).parents(".swatch").next(".swatch.has_back_cousin_color").find('input[type="radio"][data-handalize--title="'+current_selected+'"]').attr('aria-label');
        $(this).parents(".swatch").next(".swatch.has_back_cousin_color").find('input[type="radio"][data-handalize--title="'+current_selected+'"]').trigger("click");
        $(this).parents(".swatch").next(".swatch.has_back_cousin_color").find('input[type="hidden"]').val(selected_value);
      }
    });
  }
  
//   $(document).on("click",".stock_item", function(){
//     $(".soption_container .soption:last").find(".swatch-element label").click()

//   })
});